import {actionSetIsCityApplied} from 'modules/locations/slice';
import {TAppThunk} from 'core/redux/types';
import {ICity} from 'modules/locations/models';
import {APP_ROUTES_TO_URL} from 'core/modules/routing/constants';

export const changeLocation =
    (cityId: ICity['id']): TAppThunk<void> =>
    async (_, getState, {locationService}) => {
        const cities = getState().locations.cities;
        const code = cities.find((city) => city.id === Number(cityId))?.code;

        if (code) {
            try {
                const pathname = window.location.pathname || '';
                const currentUrl = new URL(window.location.href);

                // удаляем фильтры для событий
                if (pathname.startsWith(APP_ROUTES_TO_URL.events)) {
                    currentUrl.search = '';
                }

                // удаляем фильтры для каталога, поиска, скидок
                if (
                    pathname.startsWith(APP_ROUTES_TO_URL.catalog) ||
                    pathname.startsWith(APP_ROUTES_TO_URL.search) ||
                    pathname.startsWith(APP_ROUTES_TO_URL.stock)
                ) {
                    // eslint-disable-next-line require-unicode-regexp
                    currentUrl.pathname = pathname.replace(/\/filter\/.*/, '');
                }
                window.history.replaceState({}, '', currentUrl.toString());
            } catch (e) {}
            locationService.applyCityCodeUpdate(code);
            window.location.reload();
        }
    };

export const applyCity: TAppThunk<void> = async (dispatch, _, {locationService}) => {
    dispatch(actionSetIsCityApplied(true));
    locationService.applyCity();
};
